import * as React from 'react';
import './blockDescription.module.scss';
export const BlockDescription = ({ content }) => (
    <div styleName="description" dangerouslySetInnerHTML={{ __html: content }} />
);
